// extracted by mini-css-extract-plugin
export default {"checkBox":"CheckboxGroup_checkBox__pw6ZF"};